export enum NavButton {
   add= 'add',
   save= 'save',
   delete= 'delete',
   info='info',
   attach='attach',
   cancel='cancel',
   print = "print",
   ColView = "ColView"
  }